import './Button.less';

import clsx from 'clsx';
import React, { forwardRef, FunctionComponent, MouseEventHandler, ReactNode } from 'react';
import LoadingIcon from '../../icons/LoadingIcon';

export interface ButtonProps {
    children?: ReactNode;
    className?: 'green' | 'blue' | 'red' | 'violet' | 'grey' | string;
    disabled?: boolean;
    icon?: FunctionComponent;
    label?: ReactNode;
    large?: boolean;
    loading?: boolean;
    onClick?: MouseEventHandler;
    primary?: boolean;
    dataAtid?: string;
    type?: 'submit' | 'button' | 'reset';
    id?: string;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            children,
            className,
            disabled: dis,
            icon: Icon,
            label,
            large,
            loading,
            onClick,
            primary,
            dataAtid,
            type = 'button',
            ...rest
        },
        ref
    ) => {
        const disabled = dis || loading;
        return (
            <button
                ref={ref}
                className={clsx('nui-button', { primary, secondary: !primary, disabled, loading, large }, className)}
                disabled={disabled}
                type={type}
                onClick={disabled ? null : onClick}
                data-atid={dataAtid}
                {...rest}
            >
                {loading ? <LoadingIcon /> : Icon ? <Icon /> : null}
                <span>{label}</span>
                {children}
            </button>
        );
    }
);
